import { FunctionComponent } from 'react'
import { LazyLoader as LazyLoaderProps } from './LazyLoader.types'
import { CoreUxLoadingSkeleton } from '../../CoreUxLoadingSkeleton/CoreUxLoadingSkeleton'
import { UXComponentRenderer } from '../../UXComponentRenderer/UXComponentRenderer'
import { useFetchByPath } from 'src/hooks/coreUx/useFetchByPath'
import { UXComponent } from 'src/componentsV2/CoreUX/UXComponentRenderer/uxComponent'

export const buildFullPath = (path: string, params: Record<string, string>) => {
  const queryParams = Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&')

  return queryParams ? `${path}?${queryParams}` : path
}

export const LazyLoader: FunctionComponent<LazyLoaderProps> = ({
  attributes
}) => {
  const { path, params, skeletonType } = attributes
  const { response, isLoading, error } = useFetchByPath<UXComponent>(
    buildFullPath(path, params)
  )

  if (isLoading) {
    return <CoreUxLoadingSkeleton type={skeletonType} />
  }

  if (!path || error || !response) {
    return null
  }

  return <UXComponentRenderer {...response} />
}
